import Rete from 'rete';

import { distSocket } from './index';

import samplingNumber from '../../util/density/samplingNumber';
import timeSlices from '../../util/density/timeSlices';
import fillArray from '../../util/density/fillArray';

import DistPreviewControl from './DistPreviewControl';


import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';


export default class PowerComponent extends Rete.Component {

	constructor(){
		super("Power");
		this.path = ["Operation"];
		this.contextMenuName = "Power";
	}

	builder(node) {
		let inp1 = new Rete.Input('dist1',"Base", distSocket);
		let inp2 = new Rete.Input('dist2',"Power", distSocket);
		let out = new Rete.Output('dist', "Output", distSocket);
		let distPreview = new DistPreviewControl(this.editor, 'preview', true, node.id);


		return node
			.addInput(inp1)
			.addInput(inp2)
			.addControl(distPreview)
			.addOutput(out);
	}

	destroyed(node){

		// console.log(`Node ${node.id} was destroyed.`)

		// Remove all event listeners -- otherwise they will respond even if node does no longer exist


	}

	async worker(node, inputs, outputs) {
		let result = [];

		// Get all predecessors
		let predecessors = [];

		// Iterate over sockets, and inputs to collect all predecessors (their UUIDs)
		for (let [socket, inputArray] of Object.entries(inputs)) {
			for (let i = 0; i < inputArray.length; i++){
				if (inputArray[i]){
					predecessors.push(inputArray[i]['predecessor']);
				} else {
					console.log('A predecessor could not be determined. Likely because an embedded module is currently open. Any tree view will then be incomplete.')
				}
			}
		}		

		if(inputs['dist1'].length && inputs['dist1'][0].data && inputs['dist2'].length && inputs['dist2'][0].data) {
			let input1 = inputs['dist1'][0].data;

			let input2 = inputs['dist2'][0].data;
			result = [];
			for (let i = 0; i < timeSlices(); i++){
				let tmpArray = input1[i].map(function (num, idx) {
					let power = input2[i][idx]<0?0:input2[i][idx];
					return Math.pow(num, power);
				});
				result.push(tmpArray);
			}
		} else {
			result = [];
			for (let i = 0; i < timeSlices(); i++){
				let tmpArray = fillArray(0, samplingNumber());
				result.push(tmpArray);
			}
		} 
		
		// update preview if node on screen (in editor)
		let nodeSearch = this.editor.nodes.find(n => n.id == node.id);
		if (nodeSearch) {
			nodeSearch.controls.get('preview').setValue(result);
		}

		// NEW
		// Generate a new UUID for this node instance(!)
		const nodeUUID = uuidv4();

		outputs['dist'] = {
			predecessor: nodeUUID,
			data: result,
		};

		let hasPredecessors = predecessors.length > 0 ? true : false;

		// Write global node data object
		Vue.prototype.$globalSharedData.globalNodeData[nodeUUID] = {
			hasPredecessors: hasPredecessors,
			predecessors: predecessors,
			nodeID: node.id,
			data: result,
			name: node.data.title,
			nodeFunction: node.name,
			module: undefined,
			nodeData: node.data,
		}


		// ============================================================
		return;
	}
}
